exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3oLPz{position:relative;border-bottom:1px solid #d8d8d8;z-index:1;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;padding:20px}._3oLPz,._3tM0G{display:-webkit-box;display:-ms-flexbox;display:flex}._3tM0G{-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 15px 0 0;height:40px;margin-top:5px}.zrYJb{max-height:40px}.rac-v{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0;max-width:500px}._20fFl{position:relative;padding:5px 20px 0 10px;width:50%}._3uQ3g{line-height:16px;font-size:13px}.CVPWS{width:12px;top:7px;height:auto;left:-10px}._2bta8,.CVPWS{position:absolute}._2bta8{right:10px;top:10px;color:#999;font-size:22px;cursor:pointer}", ""]);

// exports
exports.locals = {
	"root": "_3oLPz",
	"warrantyBlock": "_3tM0G",
	"tooltipIcon": "zrYJb",
	"warrantyList": "rac-v",
	"option": "_20fFl",
	"optionTitles": "_3uQ3g",
	"checkBoxIcon": "CVPWS",
	"topInfoIcon": "_2bta8"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/advert/components/Warranty/Warranty.css
// module id = 3307
// module chunks = 32